// ========================================
// Inspirational Quotes
// ========================================
// Daily affirmations and quotes for the dashboard

export interface Quote {
  text: string;
  author: string;
}

export const DAILY_QUOTES: Quote[] = [
  {
    text: "The only way out is through.",
    author: "Robert Frost"
  },
  {
    text: "Feelings are just visitors. Let them come and go.",
    author: "Mooji"
  },
  {
    text: "You are allowed to be both a masterpiece and a work in progress.",
    author: "Sophia Bush"
  },
  {
    text: "What we think, we become.",
    author: "Buddha"
  },
  {
    text: "The wound is the place where the light enters you.",
    author: "Rumi"
  },
  {
    text: "Between stimulus and response there is a space. In that space is our power to choose our response.",
    author: "Viktor Frankl"
  },
  {
    text: "Self-awareness is the ability to take an honest look at your life without any attachment to it being right or wrong.",
    author: "Debbie Ford"
  },
  {
    text: "The privilege of a lifetime is to become who you truly are.",
    author: "Carl Jung"
  },
  {
    text: "Gratitude turns what we have into enough.",
    author: "Melody Beattie"
  },
  {
    text: "Your emotions make you human. Even the unpleasant ones have a purpose.",
    author: "Sabaa Tahir"
  },
  {
    text: "Acknowledging the good that you already have in your life is the foundation for all abundance.",
    author: "Eckhart Tolle"
  },
  {
    text: "The curious paradox is that when I accept myself just as I am, then I can change.",
    author: "Carl Rogers"
  },
  {
    text: "Peace comes from within. Do not seek it without.",
    author: "Buddha"
  },
  {
    text: "Healing takes time, and asking for help is a courageous step.",
    author: "Mariska Hargitay"
  },
  {
    text: "You yourself, as much as anybody in the entire universe, deserve your love and affection.",
    author: "Buddha"
  },
  {
    text: "The greatest discovery of my generation is that human beings can alter their lives by altering their attitudes of mind.",
    author: "William James"
  },
  {
    text: "Sometimes the most important thing in a whole day is the rest we take between two deep breaths.",
    author: "Etty Hillesum"
  },
  {
    text: "It's not the load that breaks you down, it's the way you carry it.",
    author: "Lou Holtz"
  },
  {
    text: "Talk to yourself like you would to someone you love.",
    author: "Brené Brown"
  },
  {
    text: "The soul always knows what to do to heal itself. The challenge is to silence the mind.",
    author: "Caroline Myss"
  }
];

// Get a random quote for the day
export const getDailyQuote = (): Quote => {
  const today = new Date();
  const dayOfYear = Math.floor(
    (today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 1000 / 60 / 60 / 24
  );
  const index = dayOfYear % DAILY_QUOTES.length;
  return DAILY_QUOTES[index]!;
};

// Get a random quote
export const getRandomQuote = (): Quote => {
  const index = Math.floor(Math.random() * DAILY_QUOTES.length);
  return DAILY_QUOTES[index]!;
};
